// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"242e03d632e129f34fd5","5338":"4975aa3512b042a7997e"}[chunkId] + ".js";
};